import getShiftDurationMinutes from './getShiftDurationMinutes';
import context from '../context';
import { getDisplayDuration } from '../utils';

export default function getShiftDisplayDuration(shift) {
  if (shift.openEnd && !context.me.isManager) {
    return '';
  }

  const decimalFormat = context.getDecimalFormat();
  return getDisplayDuration(getShiftDurationMinutes(shift), decimalFormat);
}
